module.exports = __webpack_public_path__ + "roboto-latin-ext-700-italic.woff2";